<template>
  <div class="root">
    <el-row :gutter="12" v-if="localizedObject">
      <el-col :span="12">
        <el-card v-if="localizedObject.displayName">
          <div slot="header" class="clearfix bold">
            <span>{{$t('common.displayName')}}</span>
          </div>
          <el-form :label-position="'left'" label-width="2em">
            <el-form-item :label="language" v-for="language in languages" :key="language">
              <el-input v-model="localizedObject.displayName[language]"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card v-if="localizedObject.description">
          <div slot="header" class="clearfix">
            <span>{{$t('common.description')}}</span>
          </div>
          <el-form :label-position="'left'" label-width="2em">
            <el-form-item :label="language" v-for="language in languages" :key="language">
              <el-input v-model="localizedObject.description[language]"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'LocalizedNamesEditor',
  props: {
    localizedObject: Object
  },
  computed: {
    languages () {
      return this.$store.getters.getAvailableLanguages
    }
  }
}
</script>

<style scoped>
  div.root {
    padding: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LocalizedNamesEditor.vue